import { render } from "./RetinaImg.vue?vue&type=template&id=4edffb2c&scoped=true&ts=true"
import script from "./RetinaImg.vue?vue&type=script&lang=ts"
export * from "./RetinaImg.vue?vue&type=script&lang=ts"

import "./RetinaImg.vue?vue&type=style&index=0&id=4edffb2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edffb2c"]])

export default __exports__